import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { RfpClientOneFileAllConfirmPage } from '@/pages/rfp/client/RfpClientOneFileAllConfirm/RfpClientOneFileAllConfirmPage';
import { clientRfpOneFileAllPath } from '@/utils/router/links';
export const RfpClientOneFileAllConfirm = (props) => {
    const { formDispatch, formState, offers, profile, rfp } = props;
    // 取得データ、もしくはフォーム入力値が存在しない場合はリダイレクト
    if (!formState.viewRequests || !formState.formValues) {
        return _jsx(CustomRedirect, { to: clientRfpOneFileAllPath(rfp.id) });
    }
    return (_jsx(RfpClientOneFileAllConfirmPage, { formDispatch: formDispatch, initialValues: formState.formValues, offers: offers, profile: profile, rfp: rfp, users: formState.viewRequests }));
};
